export default "__VITE_ASSET__DGFExlDk__"